import React from 'react'
import './Plans.css'
import {plansData} from '../../data/plansData'
import whiteTick from '../../assets/whiteTick.png'
export const Plans = () => {
  return (
    <div className="plans-containner" id='plans'>
        <div className="blur plans-blur-1"></div>
        <div className="blur plans-blur-2"></div>
        <div className="plans-header" >
            <span  className='stroke-text'>READY TO START</span>
            <span>YOUR JOURNEY</span>
            <span className='stroke-text'>NOW WITH US</span>
        </div>
        <div className="plans">
            {plansData.map((plans,i)=>{
                return(
                    <div className="plan"key={i}>
                        {plans.icon}
                        <span>{plans.name} </span>
                        <span>$ {plans.price}</span>
                {/* {plans features} */}
                <div className="features">
                {plans.features.map((feature)=>{
                    return(
                        <div >
                            <img src={whiteTick} alt="" />
                            {feature}
                        </div>
                    );
                })}
                </div>
                <div>
                    <span>See more benefits -> </span>
                </div>
                <button className='btn'>Join Now</button>
                    </div>
                );
            })}
        </div>
    </div>
  )
}
